import { render, staticRenderFns } from "./productTemplate.vue?vue&type=template&id=0b1d6d64&scoped=true"
import script from "./productTemplate.vue?vue&type=script&lang=js"
export * from "./productTemplate.vue?vue&type=script&lang=js"
import style0 from "./productTemplate.vue?vue&type=style&index=0&id=0b1d6d64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1d6d64",
  null
  
)

export default component.exports